import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import toast from '$$vueCmp/toast';
import app from '$$app';
import { buildAxiosErrorMeta } from './buildAxiosErrorMeta';

const internalApi = axios.create({
  baseURL: '/api/internal',
});

const api = axios.create({
  baseURL: '/api',
});

const socketInterceptor = req => {
  const methods = ['post', 'put', 'delete'];

  if (methods.includes(req.method)) {
    req.headers.socketId = app.socket?.id || '';
  }

  return req;
};

const requestIdInterceptor = req => {
  const requestId = uuidv4();

  req.headers['X-Request-Id'] = requestId;
  req.meta = req.meta || {};
  req.meta.requestId = requestId;

  return req;
};

const metaInterceptor = req => {
  req.meta = req.meta || {};
  req.meta.requestStartedAt = new Date().getTime();

  if (req.data) {
    req.meta.data = req.data;
  }

  return req;
};

api.interceptors.request.use(requestIdInterceptor);
internalApi.interceptors.request.use(requestIdInterceptor);
api.interceptors.request.use(metaInterceptor);
internalApi.interceptors.request.use(metaInterceptor);

api.interceptors.request.use(socketInterceptor);
internalApi.interceptors.request.use(socketInterceptor);

const SENSITIVE_HEADERS = new Set(['authorization', 'cookie', 'set-cookie', 'x-auth-token', 'x-csrf-token']);

function getUrlPath(rawUrl) {
  if (typeof rawUrl !== 'string') return 'unknown';
  if (rawUrl.startsWith('http://') || rawUrl.startsWith('https://')) return new URL(rawUrl).pathname;

  return rawUrl.split('?')[0];
}

// Trace headers useful for correlating with server logs
const TRACE_RESPONSE_HEADERS = ['cf-ray', 'x-request-id', 'x-trace-id', 'x-amz-request-id', 'server-timing'];

function extractRequestHeaders(config) {
  const method = config.method?.toLowerCase();
  const raw = config.headers || {};
  const merged = {};

  for (const source of [raw.common, raw[method], raw]) {
    if (!source || typeof source !== 'object') continue;
    for (const [key, val] of Object.entries(source)) {
      if (typeof val === 'object' && val !== null) continue;
      if (SENSITIVE_HEADERS.has(key.toLowerCase())) continue;
      merged[key] = val;
    }
  }

  return Object.keys(merged).length ? merged : undefined;
}

function extractTraceHeaders(response) {
  const headers = {};

  for (const key of TRACE_RESPONSE_HEADERS) {
    const val = response.headers?.[key];

    if (val != null) headers[key] = val;
  }

  return Object.keys(headers).length ? headers : undefined;
}

internalApi.interceptors.response.use(response => response,
  error => {
    // const errorData = error.response.data;
    // errorData.code = 1
    // errorData.msg = common

    // const errorData = error.response.data[0];
    // errorData.code = 3005
    // errorData.msg = specific

    // console.log(error.response.config.meta);
    // console.log(error.response.config.method);
    // console.log(error.response.config.headers);

    const failUrl = error.config?.url;

    if (failUrl?.includes('/ganttview')) {
      const options = error.response?.status === 502 || error.message === 'Network Error' || error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT' ? { timeout: false } : {};

      toast.error(__('error_tasks_api_operation'), options);
    }
    if (failUrl?.includes('/resources')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (failUrl?.includes('/custom_columns')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (failUrl?.includes('/comments')) {
      toast.error(__('error_tasks_api_operation'));
    }

    if (failUrl?.includes('/attachment')) {
      if (error.response?.data.code === 4005) {
        toast.error(__('fileUpload_limitStore', { limit: '' }));
      } else {
        toast.error(__('error_tasks_api_operation'));
      }
    }

    const { meta, errorName, capturedError } = buildAxiosErrorMeta(error, 'internalApi');

    error._meta = meta;
    error._errorName = errorName;
    error._capturedStack = capturedError.stack;
    error._capturedMessage = capturedError.message;
    throw error;
  });

api.interceptors.response.use(response => response,
  error => {
    // const errorData = error.response.data;
    // errorData.message
    // errorData.details.user
    // errorData.details.request

    // console.log(error.response.config.meta);
    // console.log(error.response.config.method);
    // console.log(error.response.config.headers);

    const failUrl = error.config?.url;

    if (failUrl?.includes('/task')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (failUrl?.includes('/link')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (failUrl?.includes('/resources')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (failUrl?.includes('/custom_columns')) {
      toast.error(__('error_tasks_api_operation'));
    }
    if (failUrl?.includes('/history')) {
      toast.error(__('error_tasks_api_operation'));
    }

    const { meta, errorName, capturedError } = buildAxiosErrorMeta(error, 'api');

    error._meta = meta;
    error._errorName = errorName;
    error._capturedStack = capturedError.stack;
    error._capturedMessage = capturedError.message;
    throw error;
  });

// old webix support

const debouncedToastCall = _.debounce(locale => {
  toast.error(locale ? __(locale) : __('error_tasks_api_operation'));
}, 300);

webix.attachEvent('onBeforeAjax', (mode, url, data, request, headers, files, promise) => {
  // add code
  headers.socketId = app.socket.id || '';
  promise.then(data => {
    // try {
    //   data.json();
    // } catch (e) {
    //   debauncedToastCall();
    // }
  }, error => {
    debouncedToastCall();
  });
});

export {
  internalApi,
  api,
};
